import * as React from 'react';
import { X } from 'lucide-react';
import { cn } from '../../lib/utils';
import { NotesToHankProvider } from '../../../application/context/NotesToHankContext/NotesToHankContext';
import V2ChatInner from '../chat/V2ChatInner';

interface ChatSidePanelProps {
  dealId: string | null;
  taskListId: string | null;
  dealInfo?: any;
  isOpen: boolean;
  onClose: () => void;
}

export function ChatSidePanel({
  dealId,
  taskListId,
  dealInfo,
  isOpen,
  onClose,
}: ChatSidePanelProps) {
  const fileInputRef = React.useRef<HTMLInputElement>(null);

  if (!isOpen || !dealId || !taskListId) {
    return null;
  }

  return (
    <div
      className={cn(
        'fixed top-0 md:top-10 bottom-0 right-0 z-50 w-full sm:w-[480px] lg:w-[540px] bg-background border-l border-border shadow-xl overflow-hidden',
        'transform transition-transform duration-300 ease-in-out',
        isOpen ? 'translate-x-0' : 'translate-x-full'
      )}
    >
      {/* Header */}
      <div className="flex items-center justify-between px-4 sm:px-6 py-3 border-b border-border bg-background">
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-foreground">AI Chat</span>
        </div>
        <button
          className="flex items-center gap-2 text-sm font-medium text-foreground hover:text-muted-foreground transition-colors px-2 py-1.5 rounded-md hover:bg-muted"
          onClick={onClose}
        >
          <X className="size-4" />
        </button>
      </div>

      {/* Chat content — skip TaskListSelector, go straight to chat */}
      <div className="flex-1 overflow-hidden h-[calc(100%-49px)]">
        <NotesToHankProvider
          key={taskListId}
          dealId={dealId}
          taskListId={taskListId}
          onOpenAttachmentPicker={() => fileInputRef.current?.click()}
        >
          <V2ChatInner
            dealId={dealId}
            dealInfo={dealInfo}
            onBack={onClose}
            fileInputRef={fileInputRef}
          />
        </NotesToHankProvider>
      </div>
    </div>
  );
}
